import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { createPath } from 'history';
import React, { Component } from 'react';
import { generateLocationFromPath } from '../../common/utils';
import { useRouter } from '../use-router';

class Redirector extends Component {
  componentDidMount() {
    const {
      to,
      location,
      push,
      params,
      query,
      actions
    } = this.props;
    const routeAttributes = {
      params,
      query,
      basePath: actions.getBasePath()
    };
    const newPath = typeof to === 'object' ? 'path' in to ? createPath(generateLocationFromPath(to.path, routeAttributes)) : createPath(to) : to;
    const currentPath = createPath(location);
    const action = push ? actions.push : actions.replace;

    if (currentPath === newPath) {
      if (process.env.NODE_ENV === 'test' || process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.warn(`You tried to redirect to the same route you're currently on: "${currentPath}"`);
      }

      return;
    }

    action(newPath);
  }

  render() {
    return null;
  }

}

_defineProperty(Redirector, "defaultProps", {
  push: false
});

export const Redirect = props => {
  const [{
    location
  }, actions] = useRouter();
  return /*#__PURE__*/React.createElement(Redirector, _extends({
    actions: actions,
    location: location
  }, props));
};